var _g, _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDocumentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_334)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 25.0255,
    cy: 24.7842,
    r: 20.4737,
    fill: "#828282",
    fillOpacity: 0.95
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.0489 33.3239H31.0045C31.684 33.3239 32.3356 33.054 32.816 32.5735C33.2965 32.0931 33.5664 31.4414 33.5664 30.762V18.8064C33.5664 18.1269 33.2965 17.4753 32.816 16.9948C32.3356 16.5144 31.684 16.2445 31.0045 16.2445L19.0489 16.2445C18.3695 16.2445 17.7178 16.5144 17.2374 16.9948C16.7569 17.4753 16.487 18.1269 16.487 18.8064L16.487 30.762C16.487 31.4414 16.7569 32.0931 17.2374 32.5735C17.7178 33.054 18.3695 33.3239 19.0489 33.3239ZM31.0045 17.9524C31.231 17.9524 31.4482 18.0424 31.6083 18.2025C31.7685 18.3627 31.8585 18.5799 31.8585 18.8064V30.762C31.8585 30.9885 31.7685 31.2057 31.6083 31.3658C31.4482 31.526 31.231 31.6159 31.0045 31.6159H30.1505V17.9524H31.0045ZM18.1949 18.8064C18.1949 18.5799 18.2849 18.3627 18.4451 18.2025C18.6052 18.0424 18.8224 17.9524 19.0489 17.9524H28.4426V31.6159H19.0489C18.8224 31.6159 18.6052 31.526 18.4451 31.3658C18.2849 31.2057 18.1949 30.9885 18.1949 30.762V18.8064Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9021 25.6388H24.6758L23.5656 26.7404C23.4048 26.9012 23.3145 27.1193 23.3145 27.3468C23.3145 27.5742 23.4048 27.7923 23.5656 27.9531C23.7264 28.1139 23.9445 28.2042 24.1719 28.2042C24.3994 28.2042 24.6175 28.1139 24.7783 27.9531L27.3402 25.3912C27.4202 25.3118 27.4837 25.2173 27.5271 25.1133C27.5705 25.0092 27.5928 24.8976 27.5928 24.7848C27.5928 24.6721 27.5705 24.5605 27.5271 24.4564C27.4837 24.3524 27.4202 24.2579 27.3402 24.1785L24.7783 21.6166C24.6989 21.5366 24.6044 21.473 24.5004 21.4297C24.3963 21.3863 24.2847 21.364 24.1719 21.364C24.0592 21.364 23.9476 21.3863 23.8435 21.4297C23.7395 21.473 23.645 21.5366 23.5656 21.6166C23.4856 21.696 23.4221 21.7905 23.3787 21.8945C23.3353 21.9986 23.313 22.1102 23.313 22.2229C23.313 22.3357 23.3353 22.4473 23.3787 22.5514C23.4221 22.6554 23.4856 22.7499 23.5656 22.8293L24.6758 23.9309H19.9021C19.6756 23.9309 19.4584 24.0208 19.2982 24.181C19.1381 24.3412 19.0481 24.5584 19.0481 24.7848C19.0481 25.0113 19.1381 25.2285 19.2982 25.3887C19.4584 25.5488 19.6756 25.6388 19.9021 25.6388Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_334",
    x: 0.551758,
    y: 0.310455,
    width: 48.9473,
    height: 48.9474,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_334"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_334",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentIcon);
export default __webpack_public_path__ + "static/media/document-icon.535f4e33c4a36f6680feb55129b37c23.svg";
export { ForwardRef as ReactComponent };